const minDate = new Date();
minDate.setFullYear(minDate.getFullYear() - 100);
const maxDate = new Date();

export const validatorDateError = (_: any, value: any) => {
  if (!value) return Promise.resolve();
  const date = new Date(value);
  if (date < minDate)
    return Promise.reject(`Date must be after ${minDate.toLocaleDateString()}`);
  if (date > maxDate)
    return Promise.reject(`Date must be before ${maxDate.toLocaleDateString()}`);
  return Promise.resolve();
};